<script>
    import TaxTable from './TaxTable.svelte';
    import {optionalTaxes} from './stores.js'
	export let tax_year;
    export let rates;
    let rateSelector = "Residential";
    let selectors = Object.getOwnPropertyNames(rates);

    const resetOptional = () => {
        optionalTaxes.set({})
    }

</script>
<div class="rate-selector">
{#each selectors as s}
    <div>
    <label for="{s}">{s}</label>
    <input id="{s}" bind:group="{rateSelector}" value="{s}" type="radio" name="rate-selector" on:change="{resetOptional}">
    </div>
{/each}
</div>
<TaxTable rates="{rates[rateSelector]}" tax_year="{tax_year}"></TaxTable>
<style>
    .rate-selector {
        display:flex;
    }
</style>